import React from "react";
import "./header.scss";

import { t } from "i18next";

import { Stack } from "react-bootstrap";

const Header = () => {
  return (
    <Stack
      direction="horizontal"
      className="w-100 d-flex px-3 py-2 justify-content-between align-items-center header-invitation"
    >
      <img src="/write_logo.svg" alt="volunteer" />

      <a href="/login">{t("login.title")}</a>
    </Stack>
  );
};

export default Header;
